import { useEffect, useRef, useState } from 'react';
import GetChannelRegistrantCounts from '../audiences/channel-registrant-counts';
import { ChannelRegistrantCounts } from '@/types/registration.types';
import { useAppSelector } from '@/store/hooks';
import { getActiveChannel } from '@/store/slices/user/selectors';
import { useProjectUuidParam } from '@/utils/use-project-uuid-param';

export default function useChannelRegistrantCounts(open: boolean) {
  const channel = useAppSelector(getActiveChannel);
  const projectUuid = useProjectUuidParam();
  const [channelRegistrantCounts, setChannelRegistrantCounts] = useState<ChannelRegistrantCounts | undefined>(
    undefined
  );

  const fetching = useRef(false);
  const fetched = useRef(0); // expensive request

  useEffect(() => {
    const now = Date.now();
    if (fetching.current || !channel || !projectUuid || !open || fetched.current > now - 1000 * 60 * 5) return;

    fetching.current = true;

    const fetchChannelRegistrantCounts = async () => {
      try {
        const channelRegistrantCounts = await GetChannelRegistrantCounts({
          channel,
          projectUuid,
        });
        setChannelRegistrantCounts(channelRegistrantCounts.data);
        fetched.current = now;
      } catch (error) {
        console.error('Error fetching registrant counts', error);
        fetching.current = false;
      }
    };

    fetchChannelRegistrantCounts();
  }, [channel, projectUuid, open]);

  return channelRegistrantCounts;
}
